const m = {
  inherit: "medium",
  large: "medium",
  medium: "small",
  small: "small"
};
export {
  m as ICON_SIZE_MAP
};
